var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNumberEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #f68926;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 24,
    cy: 24,
    r: 23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.7,16l-4.2,4.2-6.7-6.7,4.2-4.2c.7-.7,1.9-.7,2.5,0l4.2,4.2c.7.7.7,1.8,0,2.5M8.7,32.5L26.8,14.5l6.7,6.7-18.1,18.1h-6.7v-6.7M33.2,10.6l-2.8,2.8,4.2,4.2,2.8-2.8-4.2-4.2M30.9,21.3l-4.2-4.2-16.2,16.2v4.2h4.2l16.2-16.2Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberEdit);
export default __webpack_public_path__ + "static/media/numberEdit.6c3147eed67c036642d77d320ab1dd72.svg";
export { ForwardRef as ReactComponent };